export default {"src":"/_next/static/media/loading.51be6163.gif","height":64,"width":64,"blurWidth":0,"blurHeight":0};